export default __webpack_public_path__ + "static/media/Sort.7c361725.svg";